/**
 *
 * BigSelector
 *
 */
import * as React from 'react';
import Img from 'components/Img';
import { FiChevronDown } from 'react-icons/fi';

// import styled from 'styles/styled-components';

interface Props {
  imgSrc: string;
  imgAlt: string;
  title: string;
  handleClick?: any;
  chevron?: boolean;
}

function BigSelector({
  chevron = true,
  handleClick,
  imgAlt,
  imgSrc,
  title,
}: Props) {
  return (
    <button className="big-selector flex flex-col" onClick={handleClick}>
      <Img src={imgSrc} alt={imgAlt} className="self-center h-10 w-10" />
      <div className="flex items-center">
        <div className="flex items-center justify-center w-20 mt-1">
          <div className="flex justify-center items-center -mt-1 text-sm leading-none xl:text-normal text-gray-800 h-8">
            {title}
          </div>
        </div>
        {chevron && <FiChevronDown className="h-4 w-4" />}
      </div>
    </button>
  );
}

export default BigSelector;
